import React from "react";
import CreateEvent from "../components/ui/create-event";

const CreateEventPage = () => {
  return <CreateEvent />;
};

export default CreateEventPage;
